<template>
	<v-card>
		<v-toolbar flat color="dark" dark>
			<v-toolbar-title>
				<span class="pl-2">OSBOD Urenverantwoording</span>
			</v-toolbar-title>
		</v-toolbar>
		<v-card-title>
			<v-text-field v-model="search" append-icon="mdi-magnify" label="Filter" single-line hide-details></v-text-field>
		</v-card-title>

		<v-data-table :headers="headers" :items="data" :search="search" :loading="loading">
			<template v-slot:top>
				<v-toolbar dark dense color="primary" flat class="mb-1">
					<v-btn depressed class="ml-2" @click="setEmployeeTimesheet()" color="inverted">
						<v-icon class="pr-2">mdi-plus-circle</v-icon>Nieuwe Urenverantwoording
					</v-btn>
					<v-spacer></v-spacer>
					<v-select
						v-model="selectedMonth"
						:items="months"
						item-text="text"
						item-value="value"
						label="Maand"
						dense
						hide-details
						dark
						class="mt-0 pt-0 mr-2"
						style="max-width: 180px"
					></v-select>
					<v-btn
						depressed
						class="mr-2"
						color="inverted"
						:loading="reportLoading"
						:disabled="reportLoading || !selectedMonth"
						@click="openMonthlyReport()"
					>
						<v-icon class="pr-2">mdi-file-pdf-box</v-icon>Maandrapport
					</v-btn>
				</v-toolbar>
			</template>
			<template v-slot:item.action="{ item }" >
				<v-icon @click="handleClick(item.id)">mdi-account-edit</v-icon>
			</template>
		</v-data-table>

		<v-dialog v-model="noReportDialog" max-width="480">
			<v-card>
				<v-card-title class="headline">Geen rapportgegevens</v-card-title>
				<v-card-text>
					{{ noReportMessage }}
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" text @click="noReportDialog = false">Sluiten</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-card>
</template>
 
 <script>
import Axios from "axios";
//import _ from "lodash";
import { API_ROOT } from "../../config";
import { openPdf } from "../../services/reportService";
console.log(API_ROOT.osbod_salary);
const ax = Axios.create({
	baseURL: API_ROOT["osbod_salary"],
	timeout: 60000
});

export default {
	name: "timesheets",
	data() {
		return {
			//user: localStorage.getItem("user"),
			search: "",
			reportLoading: false,
			noReportDialog: false,
			noReportMessage: "",
			selectedMonth: new Date().getMonth() + 1,
			months: [
				{ value: 1, text: "Januari" },
				{ value: 2, text: "Februari" },
				{ value: 3, text: "Maart" },
				{ value: 4, text: "April" },
				{ value: 5, text: "Mei" },
				{ value: 6, text: "Juni" },
				{ value: 7, text: "Juli" },
				{ value: 8, text: "Augustus" },
				{ value: 9, text: "September" },
				{ value: 10, text: "Oktober" },
				{ value: 11, text: "November" },
				{ value: 12, text: "December" }
			],
			headers: [
				{
					text: "",
					align: "center",
					sortable: false,
					value: "action"
				},
				{ text: "Schooljaar", value: "tbl_sys_schoolyear.name" },
				{ text: "Periode", value: "tbl_sys_periode.name" },
				{ text: "Coordinator", value: "tbl_user.display_name" },
				{ text: "Datum", value: "dedicated_date" },
				{ text: "Uren", value: "tbl_sys_hour.name" },
				{ text: "Minuten", value: "tbl_sys_minute.name" },
				{ text: "Werklocatie", value: "tbl_sys_worklocation.name" },
				{ text: "Uitgevoerde taken", value: "tbl_sys_task.name" },
				// { text: "Urenverantwoording", value: "tbl_sys_schoolyear.name" },
				// { text: "First Check", value: "firstcheckby"},
				// { text: "Second Check",	value: "secondcheckby"},
				// { text: "Active", value: "tbl_timesheet.timesheet_active" }

			],
			// semesters: [],
			// studies: [],
			// subjects: [],
			// subjecttypes: [],
			// selected_subject: null,
			// selected_kwalificatie: null,
			// selected_deelkwalificatie: null,
			// selected_semester: null,
			// schoolyear: [],
			// selected_schoolyear: null,
			data: [],
			user: JSON.parse(localStorage.getItem("user")),
			// banktypes: [],
			isEmpty: false,
			loading: false,
			isPaginated: true,
			isPaginationSimple: false,
			defaultSortDirection: "asc",
			currentPage: 1,
			perPage: 15
		};
	},
	created: function() {
		// this.getBanktypes();
		this.getEmployeeTimesheets();
	},
	watch: {
		// selected_kwalificatie: function(value) {
		// 	this.getStudySubjecttype(value);
		// 	console.log(value);
		// }
	},
	computed: {
		selectedMonthLabel: function() {
			var self = this;
			var found = this.months.find(function(m) {
				return m.value === self.selectedMonth;
			});
			return found ? found.text : String(this.selectedMonth);
		}
	},
	methods: {
		handleClick(id) {
			this.$router.push({
				path: "/schooladmin/employeetimesheet/update/" + id
			});
		},
		setEmployeeTimesheet: function() {
			this.$router.push({
				path: "/schooladmin/employeetimesheet/new"
			});
		},
		monthFromDedicatedDate: function(dedicatedDate) {
			if (!dedicatedDate) {
				return null;
			}
			var raw = String(dedicatedDate).slice(0, 10);
			var parts = raw.split("-");
			if (parts.length < 2) {
				return null;
			}
			var month = Number(parts[1]);
			return Number.isNaN(month) ? null : month;
		},
		hasRecordsForSelectedMonth: function() {
			var self = this;
			var month = Number(this.selectedMonth);
			return (this.data || []).some(function(row) {
				return self.monthFromDedicatedDate(row.dedicated_date) === month;
			});
		},
		showNoReportPopup: function(message) {
			this.noReportMessage =
				message ||
				"Er zijn geen urenverantwoordingsrecords voor " +
					this.selectedMonthLabel +
					" in het actieve schooljaar. Het rapport kan niet worden aangemaakt.";
			this.noReportDialog = true;
		},
		openMonthlyReport: async function() {
			var self = this;
			if (!this.user || !this.user.id || !this.selectedMonth) {
				return;
			}
			if (!this.hasRecordsForSelectedMonth()) {
				this.showNoReportPopup();
				return;
			}
			this.reportLoading = true;
			try {
				await openPdf("urenverantwoording-employees", {
					user_id: this.user.id,
					sel_month: this.selectedMonth
				});
			} catch (e) {
				var message =
					(e && e.message) ||
					"Kon het maandrapport niet genereren.";
				if (e && (e.status === 404 || e.status === 400)) {
					self.showNoReportPopup(message);
				} else if (this.$toast) {
					this.$toast.error(message);
				} else {
					alert(message);
				}
			} finally {
				self.reportLoading = false;
			}
		},
		getEmployeeTimesheets: function() {
			var self = this;
			this.loading = true;

			ax.get("/schoolyear/all")
				.then(function(schoolyearResponse) {
					var activeIds = (schoolyearResponse.data || [])
						.map(function(sy) {
							return Number(sy.id);
						})
						.filter(function(id) {
							return !Number.isNaN(id);
						});

					return ax
						.get("/employee_timesheet/user_task/", {
							params: {
								user_id: self.user.id
							}
						})
						.then(function(response) {
							var rows = response.data || [];
							self.data = rows.filter(function(row) {
								var schoolyearId =
									row.schoolyear_id != null
										? Number(row.schoolyear_id)
										: row.tbl_sys_schoolyear &&
										  row.tbl_sys_schoolyear.id != null
											? Number(row.tbl_sys_schoolyear.id)
											: null;
								return (
									schoolyearId != null &&
									activeIds.indexOf(schoolyearId) !== -1
								);
							});
							console.log(
								"Urenverantwoording fetched (active schoolyear)...",
								self.data
							);
						});
				})
				.catch(function(err) {
					console.error(err);
					self.data = [];
				})
				.finally(function() {
					self.loading = false;
				});
		},
		// getBanktypes: function() {
		// 	var self = this;
		// 	ax.get("/banktype/all").then(function(response) {
		// 		console.log(response.data);
		// 		self.banktypes = response.data;
		// 	});
		// }
	}
};
</script>
 
 <!-- Add "slot-scoped" attribute to limit CSS to this component only -->
 <style slot-scoped>
</style>
